const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

export const API_ENDPOINTS = {
  CHAT: `${API_BASE_URL}/speakWithAI`,
  PUNCTUATE: `${API_BASE_URL}/punctuateText`,
  PROCESS_IMAGE: `${API_BASE_URL}/processImage`,
  CHECK_QUIZ_ANSWER: `${API_BASE_URL}/checkQuizAnswer`,
  TRANSLATE: `${API_BASE_URL}/translateText`,
  SEARCH_YOUTUBE: `${API_BASE_URL}/searchYoutube`,
};